import gql from 'graphql-tag.macro'

export const newsTargetGroupQuery = gql`
  {
    taxonomyTermQuery(
      offset: 0
      limit: 200
      filter: {
        conditions: [
          {operator: EQUAL, field: "vid", value: ["news_categories"]}
          {field: "status", value: ["1!"], operator: EQUAL}
        ]
      }
    ) {
      entities {
        entityId
        entityLabel
        ... on TaxonomyTermNewsCategories {
          fieldFilterVisible
          weight
          status
          parent {
            targetId
          }
        }
      }
    }
  }
`
